export default {
  auth: {
    title: 'Users & Permissions',
    manageUsers: 'Manage Users',
    manageRoles: 'Manage Roles',
    manageScopes: 'Manage Scope',
  },
}
